<span (click)="openDialog()" class="stat-text-link" data-dtm="footer"
  >{{label}}</span
>
